import NumberCore from "@/modules/NumberCore/NumberCore";

export const wrapAutoCancellableLast = (
	runRequest: any,
	defaultValueGetter?: any
) => {
	let lastRequestId = NumberCore.uniqueId;

	return async (...args: any[]) => {
		let currentRequestId = NumberCore.uniqueId;

		lastRequestId = currentRequestId;

		const response = await runRequest(...args);

		return currentRequestId === lastRequestId
			? response
			: ((defaultValueGetter && defaultValueGetter()) || null);
	};
};